exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".chartist-tooltip {\n  position: absolute;\n  display: inline-block;\n  opacity: 0;\n  min-width: 5em;\n  padding: .5em;\n  background: #FF6363;\n  color: white;\n  border-radius: 10px;\n  font-family: \"Nunito Sans\", \"HelveticaNeue-Light\", \"Helvetica Neue Light\", \"Helvetica Neue\", Helvetica, Arial, \"Lucida Grande\", sans-serif; \n  font-size: 14px;\n  font-weight: 300;\n  text-align: center;\n  pointer-events: none;\n  z-index: 1;\n  -webkit-transition: opacity .2s linear;\n  -moz-transition: opacity .2s linear;\n  -o-transition: opacity .2s linear;\n  transition: opacity .2s linear; }\n  .chartist-tooltip:before {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    margin-left: -15px;\n    border: 15px solid transparent;\n    border-top-color: #FF6363; }\n  .chartist-tooltip.tooltip-show {\n    opacity: 1; }\n\n.ct-area, .ct-line {\n  pointer-events: none; }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./client/src/styles/chartist-plugin-tooltip.global.css
// module id = 512
// module chunks = 0